import { useState } from 'react'
import {
    ScoopButton,
    ScoopCheckbox,
    ScoopColumn,
    ScoopDialog,
    ScoopDivider,
    ScoopRow,
    ScoopStepper,
    ScoopText,
    ScoopTextField,
} from '../../../../ui'
import styles from './SettingsModal.module.scss'
const SettingsModal = ({
    onClose,
    setStep,
    steps,
    activeStep,
    goBack,
    inboxName,
    isBlending,
    save,
}) => {
    const [queryOneCheck, setQueryOneCheck] = useState(false)
    const [queryTwoCheck, setQueryTwoCheck] = useState(false)

    const [currentInboxName, setCurrentInboxName] = useState(inboxName)
    const [inboxDescription, setInboxDescription] = useState('')

    const handleSave = () => {
        save()
        onClose()
    }

    return (
        <ScoopDialog
            maxWidth="lg"
            open
            onClose={() => {
                onClose()
                setStep(0)
            }}
            actions={
                <>
                    <ScoopButton variant="grey" onClick={goBack}>
                        Back
                    </ScoopButton>
                    <ScoopButton onClick={handleSave}>Create Dataset</ScoopButton>
                </>
            }
            title={
                <ScoopStepper activeStep={activeStep} steps={steps} className={styles.stepper} />
            }
        >
            <ScoopDivider />
            <ScoopColumn className={styles.container}>
                <ScoopText className={styles.title}>Settings</ScoopText>
                <ScoopColumn className={styles.formContainer}>
                    <ScoopTextField
                        onChange={(e) => setCurrentInboxName(e.target.value)}
                        value={currentInboxName}
                        label={'Name'}
                    />
                    <ScoopTextField
                        onChange={(e) => setInboxDescription(e.target.value)}
                        value={inboxDescription}
                        label={'Description'}
                        multiline
                        rows={5}
                    />
                    {isBlending && (
                        <>
                            <ScoopRow className={styles.checkboxRow}>
                                <ScoopCheckbox
                                    checked={queryOneCheck}
                                    onChange={() => setQueryOneCheck(!queryOneCheck)}
                                />
                                <ScoopColumn className={styles.checkboxContent}>
                                    <ScoopText className={styles.checkboxTitle}>
                                        Queried dataset 1
                                    </ScoopText>
                                    <ScoopText className={styles.checkboxDescription}>
                                        Reprocess whenever dataset is updated
                                    </ScoopText>
                                </ScoopColumn>
                            </ScoopRow>
                            <ScoopRow className={styles.checkboxRow}>
                                <ScoopCheckbox
                                    checked={queryTwoCheck}
                                    onChange={() => setQueryTwoCheck(!queryTwoCheck)}
                                />
                                <ScoopColumn className={styles.checkboxContent}>
                                    <ScoopText className={styles.checkboxTitle}>
                                        Queried dataset 2
                                    </ScoopText>
                                    <ScoopText className={styles.checkboxDescription}>
                                        Reprocess whenever dataset is updated
                                    </ScoopText>
                                </ScoopColumn>
                            </ScoopRow>
                        </>
                    )}
                </ScoopColumn>
            </ScoopColumn>
        </ScoopDialog>
    )
}

export default SettingsModal
